// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import PrivacyPage from "../pages/Privacy/Privacy";
const __wvcRoutePaths = ["/PrivacyPage", "/privacy-policy"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["404", "cart", "cartpage", "checkout", "checkoutpage", "contact", "contactpage", "home", "homepage", "my-account", "myaccountpage", "post", "privacy-policy", "privacypage", "returns-refunds", "returnspage", "search", "shipping-policy", "shippingpage", "shop", "shoppage", "term", "terms-of-service", "termspage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<PrivacyPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<PrivacyPage />} />
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
